import * as Sentry from '@sentry/gatsby'

process.env.GATSBY_ACTIVE_ENV === 'production' &&
	Sentry.init({
		dsn: 'https://427748d567d94d6fb7b66bc2608d29d0@o1232455.ingest.sentry.io/4505041781194752',
		tracesSampleRate: 0.25,
		release: process.env.BUILD_ID
	})
